<template>
  <div class="main-page home_page" style="padding:0" :class="isflat ? 'page-home-flat' : ''">
    <HomeHead />
    <!-- 广告banner -->
    <div class="swiper-panel">
      <HomeSwiper class="radius" />
    </div>
    <!-- 服务 -->
    <div class="service-box grayscale">
      <div :class="['per-block', 'p' + key]" v-for="(items, key ) in prolist" :key="'key-item' + key">
        <div class="per-title">
          {{ items.name }}
        </div>
        <div class="per-content">
          <div @click="toNewurl(item)" :class="['item', 'c' + (index + 1)]" v-for="(item, index) in items.list " :key="'key-advisory' + index">
            <div class="imgs" v-if="item.icon">
              <img :src="item.icon" alt="">
            </div>
            <div class="item-con">

              <div class="title">
                {{ item.title }}

              </div>
              <div class="intro" v-if="item.intro" v-html="item.intro" />
            </div>
          </div>
          <template v-if="items.pufa && key == 2">
            <div class="item" @click="toPufa(issue)" v-for="(issue, index) in items.pufa " :key="'key-iss' + index">
              {{ issue.title }}
            </div>
          </template>
        </div>
      </div>
      <!-- 全部服务 -->
      <div class="per-block p3 ">
        <div class="per-title">
          更多服务
        </div>
        <div class="per-content">
          <template v-for="(allitem, index) in allservice ">
            <div @click="toNewurl(allitem)" v-if="index < 11" :class="['item', 'c' + (index + 1)]" :key="'key-sss' + index">
              <div class="imgs" v-if="allitem.icon">
                <img :src="allitem.icon" alt="">
              </div>
              <div>

                <div class="title">
                  {{ allitem.title }}
                </div>
                <div class="intro" v-if="allitem.intro"> {{ allitem.intro }}</div>
              </div>
            </div>
          </template>
          <div @click="$router.push('/allservice')" class="item c11">
            <div class="title">
              全部服务
            </div>
          </div>
        </div>
      </div>
    </div>
    <HomeFoot />

    <HomefloatAd></HomefloatAd>
    <Rightslide v-model="slide" @getClose="slide.show = false ">
      <template slot="content">
        <div class="title">
          {{ slide.title }}
        </div>
        <div class="detail" v-html="slide.detail">
        </div>
      </template>
    </Rightslide>
  </div>
</template>

<script>
import Rightslide from '@/components/RightSlide'
import HomeHead from '@/components/home/HomeHead'
import HomeSwiper from '@/components/home/HomeSwiper'
import HomeFoot from '@/components/home/HomeFoot'
import HomefloatAd from '@/components/home/HomefloatAd'

export default {
  name: 'home',
  components: {
    Rightslide,
    HomeHead,
    HomeSwiper,
    HomeFoot,
    HomefloatAd
  },
  data () {
    return {
      slide: {
        show: false,
        title: '',
        detail: ''
      },

      prolist: {
        0: {
          name: '法律服务',
          list: [
            {
              title: '精准法律咨询',
              intro: '只需几分钟即可免费获得精准法律意见书已免费服务560万余人',
              origin: 'advisory',
              icon: '/img/ui/home/logo_advice.png'
            },
            {
              "title": "智能要素式起诉状/答辩状",
              "path": "/indictment",
              intro: '智能化引导，专业准确',
              "icon": "https://qiniu.laway.cn/publaw/ccd8bae820ae11f0ac5dfa2800182ac7.png"
            },
            {
              title: '法律文书模板',
              path: '/service/11',
              icon: '/img/ui/home/logo_instrument.png'
            },
            {
              title: '留言咨询',
              path: '/service/10',
              icon: '/img/ui/home/message.png'
            }
          ]
        },
        1: {
          name: '业务申办查询',
          list: [
            {
              title: '法律援助',
              // intro: '提供法律援助资格预判、在线申请查询服务',
              path: '/service/6',
              icon: '/img/ui/home/logo_legalaid.png'
            },
            {
              title: '人民调解',
              path: '/service/0',
              icon: '/img/ui/home/logo_mediation.png'
            },
            {
              title: '公证服务',
              path: '/service/2',
              icon: '/img/ui/home/logo_notarization.png'
            },
            {
              title: '司法鉴定',
              path: '/service/3',
              icon: '/img/ui/home/logo_identify.png'
            },
            {
              title: '行政复议',
              path: '/service/fuyi',
              icon: 'https://yn.12348.laway.cn/los/art_img/202508/872ac1d082ec11f0bf37b4055d0b0812.png'
            },
            {
              title: '仲裁服务',
              path: '/service/13',
              icon: '/img/ui/home/logo_arbitration.png'
            },

          ]
        },
        2: {
          name: '学法用法',
          list: [
            {
              title: '普法动态',
              intro: '',
              path: '/pufa?show_tab=true',
              icon: '/img/ui/home/logo_pufa.png'
            },
            {
              title: '以案释法',
              intro: ' ',
              path: '/yasf',
              icon: '/img/ui/home/logo_yasf.png'
            }
          ],
          pufa: [
            { title: '民间借贷', path: '/yasf?categoryId=2BC2D0BD27304594AF57BB412E9DB56A&title=民间借贷' },
            { title: '婚姻家庭', path: '/yasf?categoryId=4C98091CBA5046B5992C58EA13510F1A&title=婚姻家庭' },
            { title: '劳动纠纷', path: '/yasf?categoryId=B2D32B0FD922438FBE8547C19A23E586&title=劳动纠纷' },
            { title: '房屋买卖', path: '/yasf?categoryId=22BBD0FCF64F493BA117EB869CE04379&title=房屋买卖' },
            { title: '交通事故', path: '/yasf?categoryId=7D29A635C2214853BA805834A41BD07C&title=交通事故' },
            { title: '消费维权', path: 'yasf?categoryId=61537ABDE5164862962606472C1DF8C2&title=消费维权' },
            { title: '产品质量', path: 'yasf?categoryId=3A239EE58D6242AC999439C213D97439&title=产品质量' },
            { title: '更多', path: '/yasf' }
          ]
        }
      },
      allservice: [
        {
          title: '企业法治体检', isexam: true, intro: '发现企业潜在的法律风险，出具法律风险评估报告',
          icon: '/img/ui/home/icon_exam.png'
        },
        { title: '机构人员查询 ', path: '/map' },
        { title: '法律法规查询 ', path: '/law' },
        { title: '案例库查询', path: '/case' },
        { title: '经典案例', path: '/caselibrary' },
        { title: '一带一路服务', path: '/service/9' },
        { title: '法律计算器', iscalc: true },
        { title: '乡村振兴法律服务', path: '/service/7' },
      ],
      isflat: false // 是否是平板
    }
  },
  computed: {
    pointConfig () {
      return this.$point && this.$point.config ? JSON.parse(this.$point.config) : ''
    },
  },
  methods: {
    async toNewurl (item) {
      if (item && item.origin === 'advisory') {
        this.toAdvisorys()
      }
      if (item.iscalc) {
        this.toCalc()
      }
      if (item.isexam) {
        this.toExam()
      }
      if (item && item.path === '/law') {
        this.toLaw()
        return
      }
      if (item && item.path) {
        this.$router.push(item.path)
      }
      if (item && item.link) {
        window.location.href = item.link
      }
    },
    toPufa (item) {
      if (item && item.path) {
        this.$router.push(item.path)
      }
    }
  },
  async mounted () {
    const screenheight = document.documentElement.clientHeight
    if (screenheight === 1200) {
      this.isflat = true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.$point.geography) {
        vm.$router.push('/initial')
        return
      }
      if (vm.pointConfig && (vm.pointConfig.isdemo || vm.pointConfig.hasVideo)) {
        // 去往演示页面
        vm.$router.push('/theme/VideoHome')
      }
      const point = vm.$store.state.device.point.config && JSON.parse(vm.$store.state.device.point.config)
      if (point && point.zd_skin) {
        // 终端机皮肤存在的话跳转
        vm.$router.push('/theme/' + point.zd_skin)
      }
    })
  }

}
</script>
<style lang="stylus">
.home_page {
  position: relative;
  box-sizing: border-box;
  padding: 0.44rem 0 0;
  overflow: hidden;

  &.page-home-flat {
    padding-top: 1rem;
  }

  .abut-us-panel {
    position: relative;
    width: 8rem;

    .title {
      font-size: 0.3rem;
      font-weight: 600;
      padding: 0.15rem 0;
    }

    .company-erweima {
      position: absolute;
      top: 0.1rem;
      right: 0;
      text-align: center;

      p {
        padding: 0.1rem 0;
        font-size: 0.16rem;
      }
    }

    .company-name {
      height: 0.8rem;
      display: flex;
      padding: 0.1rem 0;
      flex-direction: column;
      justify-content: space-between;

      h1 {
        font-size: 0.24rem;
      }

      h3 {
        color: #ff6700;
      }
    }

    .company-info-panel {
      line-height: 1.6;
      padding: 0.2rem 0;
    }
  }

  .swiper-panel {
    height: 2.26rem;
    padding: 0 0.6rem;
  }

  .service-box {
    display: flex;
    padding: 0 0.6rem;
    justify-content: space-between;

    .per-block {
      width: 4.2rem;

      .per-title {
        padding: 0.25rem 0;
        line-height: 0.3rem;
        font-size: 0.25rem;
        color: #fff;
      }

      .item {
        width: 100%;
        color: #fff;
        border-radius: 0.08rem;
        background-color: rgba(255, 255, 255, 0.2);
        border: solid 1px rgba(255, 255, 255, 0.2);
        margin-bottom: 0.15rem;
        box-sizing: border-box;

        &:active {
          background-color: rgba(255, 255, 255, 0.3);
          border: solid 1px rgba(255, 255, 255, 0.3);
        }

        .title {
          line-height: 1.2;
        }

        .intro {
          font-size: 0.15rem;
          padding-top: 0.1rem;
          line-height: 0.24rem;
          color: rgba(255, 255, 255, 0.6);
        }
      }

      &.p0 {
        .per-content {
          display: flex;
          flex-wrap: wrap;
        }

        .c1, .c2 {
          width: 100%;
          height: 1.43rem;
          display: flex;
          align-items: center;

          .imgs {
            width: 0.81rem;
            height: 0.81rem;
            flex-shrink: 0;
            margin: 0 0.15rem 0 0.3rem;

            img {
              width: 100%;
            }
          }

          .item-con {
            flex: 1;
          }

          .intro {
            padding-top: 0.1rem;
          }
        }

        .c3 {
          height: 1.43rem;
          width: 2.04rem;
          align-items: center;
          line-height: 1.2;
          display: flex;
          margin-right: 0.12rem;

          .imgs {
            margin: 0 0.1rem 0 0.16rem;
            width: 0.69rem;

            img {
              width: 0.69rem;
              height: 0.69rem;
            }
          }
        }

        .c4 {
          display: flex;
          height: 1.43rem;
          width: 2.04rem;
          align-items: center;

          .imgs {
            margin: 0 0.1rem 0 0.16rem;
            width: 0.69rem;

            img {
              width: 0.69rem;
              height: 0.69rem;
            }
          }

          .item-con {
            flex: 1;
          }

          .title {
            line-height: 1.2;
          }
        }
      }

      &.p1 {
        .per-content {
          display: flex;
          flex-wrap: wrap;
        }

        .item-con {
          flex: 1;
        }

        .item {
          height: 1.43rem;
          width: 2.04rem;
          display: flex;
          align-items: center;

          .imgs {
            margin: 0 0.1rem 0 0.16rem;
            width: 0.69rem;

            img {
              width: 0.69rem;
            }
          }

          &:nth-child(odd) {
            margin-right: 0.12rem;
          }
        }
      }

      &.p2 {
        .per-content {
          display: flex;
          flex-wrap: wrap;
        }

        .item {
          width: 2.04rem;
          height: 0.64rem;
          box-sizing: border-box;
          line-height: 0.62rem;
          text-align: center;
          font-size: 0.2rem;
          color: #fff;
          padding: 0 0.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:nth-child(odd) {
            margin-right: 0.12rem;
          }
        }

        .c1, .c2 {
          height: 1.43rem;
          display: flex;
          align-items: center;

          .imgs {
            margin: 0 0.1rem 0 0.16rem;
            width: 0.69rem;

            img {
              width: 0.68rem;
            }
          }
        }
      }

      &.p3 {
        .per-content {
          display: flex;
          flex-wrap: wrap;
        }

        .item {
          width: 2.04rem;
          height: 0.64rem;
          box-sizing: border-box;

          .title {
            line-height: 0.62rem;
            text-align: center;
            font-size: 0.2rem;
            color: #fff;
            padding: 0 0.1rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &:nth-child(even) {
            margin-right: 0.12rem;
          }

          &.c1 {
            width: 100%;
            height: 1.43rem;
            display: flex;
            padding-left: 0.1rem;
            align-items: center;

            .imgs {
              margin: 0 0.1rem 0 0.16rem;
              width: 0.69rem;
              flex-shrink: 0;

              img {
                width: 100%;
              }
            }

            .title {
              text-align: left;
              line-height: 1;
              padding: 0;
            }
          }

          &.c11, &.c12 {
            margin-bottom: 0;
          }

          a.title-link {
            line-height: 0.62rem;
            text-align: center;
            font-size: 0.2rem;
            color: #fff;
            padding: 0 0.1rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &.c11, &.c12 {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

.login-input {
  font-size: 0.26rem;
  line-height: 1;
  height: 0.8rem;
}

.input-label {
  font-size: 0.3rem;
  line-height: 0.8rem;
}

.login-btns {
  color: #fff !important;
}

.login-row {
  margin-bottom: 0.2rem;
}

.setting-btn {
  text-decoration: none;
  color: #fff;
  margin-left: 0.4rem;
}
</style>
